import React from 'react';
import { BOOKING_HREF, handleBookingClick, isBookingHref } from '../../utils/bookingNavigation';
import './Button.css';

const Button = ({ variant = 'primary', children, onClick, href, icon }) => {
  const Tag = href ? 'a' : 'button';
  const bookingLink = href && isBookingHref(href);

  const handleClick = event => {
    if (bookingLink) handleBookingClick(event);
    onClick?.(event);
  };

  return (
    <Tag
      className={`btn btn--${variant}`}
      onClick={handleClick}
      href={href || undefined}
    >
      {icon && <span className="btn__icon">{icon}</span>}
      {children}
    </Tag>
  );
};

export { BOOKING_HREF };
export default Button;
